export const transactionHistoryHeader = [
    "Product Name","Date and time","Amount","Invoice","Status","Payment"
]

export const transactionHistoryBodyData = [
    {
        img:"05",
        name:"Nike Sports",
        pending:"Item Sold",
        date:"Jan 25, 2022 (08:35:45)",
        amount:"$243 USD",
        invoice:"#PH6539",
        status:"Success",
        color:"success",
        payment:"Paypal"
    },
    {
        img:"06",
        name:"iphone 14 Pro",
        pending:"Bought item",
        date:"Feb 19, 2022 (12:20:40)",
        amount:"$356 USD",
        invoice:"#LH98NH",
        status:"Pending",
        color:"secondary",
        payment:"Credit Card"
    },
    {
        img:"07",
        name:"Headphone",
        pending:"Bought item",
        date:"May 10, 2022 (04:39:13)",
        amount:"$845 USD",
        invoice:"#D987BH",
        status:"Success",
        color:"success",
        payment:"Paypal"
    }
]